export const ocvFeedbackPanelLabel = "rzUHSc";
export default {ocvFeedbackPanelLabel};